// English translation file

const progress_bar = {
  campaign_details: 'Campaign Details',
  data_upload: 'Data Upload',
  questionnaire: 'Questionnaire',
  referral_questionnaire: 'Referral Questionnaire',
  incentive: 'Incentive',
  referral_incentive: 'Referral Incentive',
  compose_creative: 'Compose Creative',
  emails: 'Emails',
  happiness_check: 'Happiness Check',
  finalise: 'Finalise',
}

const campaign_details = {
  select_customer: 'Select Customer',
  customer: 'Customer',
  campaign_group: 'Campaign Group',
  select_group: 'Select Group',
  no_group: 'No Group',
  select_customer_first: 'Select a customer first',
  details: 'Details',
  campaign_name: 'Campaign Name',
  company_name: 'Company Name',
  start_date: 'Start Date',
  end_date: 'End Date',
  postage_preferences: 'Postage Preferences',
  sender_address: 'Sender Address',
  referral_campaign: 'Send a friend',
  include_referral: 'Would you like to include a referral campaign?',
  birthday_campaign: 'Birthday Campaign',
  include_birthday:
    "A birthday campaign enables sending incentives for your client's birthday",
  type_of_campaign: 'Type of campaign',
  offline: 'Offline',
  offline_description: 'Postcard campaign',
  online: 'Online',
  online_description: 'Email campaign',
  email_address: 'Email Address or URL',
  email_address_label:
    'The Address will appear on the postcard in case of an offline campaign',
  privacy_link: 'Privacy Statement Link',
  privacy_link_description:
    'The link to your privacy statement that will be included in our terms and conditions',
  send_email_date: 'Date time to send email campaign',
}

const languages = {
  en: 'Schakel over naar Engels',
  nl: 'Switch to Nederlands',
}

const navigation = {
  create_campaign: 'Create Campaign',
  dashboard: 'Dashboard',
  campaign_list: 'Campaign list',
  agenda: 'Agenda',
  log_out: 'Log out',
  admin: 'Admin',
  hi: 'Hi',
  action_panel: 'Action Panel',
  get_started: 'To get started, simply select an action from',
  get_started_2: 'the action panel',
  incentives: 'Incentives',
  sku_builder: 'SKU list',
}

const campaign_list = {
  done: 'Done',
  in_progress: 'In Progress',
  upcoming: 'Upcoming',
  draft: 'Draft',
  campaign_list: 'Campaign List',
  customer: 'CUSTOMER',
  campaign_name: 'CAMPAIGN NAME',
  start_date: 'START DATE',
  end_date: 'END DATE',
  status: 'STATUS',
  claimed_gifts: 'CLAIMED GIFTS',
  details: 'Details',
  edit: 'Edit',
  actions: 'ACTIONS',
  campaign_data: 'CAMPAIGN DATA',
  duplicate: 'Duplicate',
  execute_failed_title: 'Cannot execute campaign',
  open_campaign: 'Open campaign',
  // Pagination and filtering
  search_placeholder: 'Search campaigns...',
  filter_by_customer: 'Filter by Customer',
  all_customers: 'All customers',
  page_info: 'Page {{currentPage}} of {{totalPages}}',
  previous: 'Previous',
  next: 'Next',
}

const questionnaire = {
  theme: 'Theme',
  select_theme: 'By choosing a theme you’d set the style of your campaign',
  referral_theme_preselected:
    'The theme of the campaign is set in the original questionnaire',
  questionnaire: 'Questionnaire',
  select_questionnaire: 'You can choose and adjust a set of questions below',
  questionnaire_1: {
    name: 'Product / Service Feedback Survey',
  },
  questionnaire_2: { name: 'Customer Satisfaction Survey' },
  review_selected_questionnaire: 'Review Selected Questionnaire',
  referral_campaign: 'Referral Campaign',
  referral_campaign_description:
    'Enables customers to easily share the campaign with their friends and contacts through our referral feature.',
}
const optional_question = {
  title: 'Add New Question',
  description: 'You can add your own question here',
  question: 'Question',
  type: 'Type',
  cancel: 'Cancel',
  add_question: 'Add Question',
  reverse_changes: 'Reverse Changes',
  question_placeholder:
    'How likely is it you would recommend us to a friend or colleague?',
  type_placeholder: 'Open Question',
}
const validation_messages = {
  required: 'This field is required',
  Required: 'This field is required',
  invalid_date: 'Invalid date',
  start_date_too_soon_offline:
    'Please select a date at least 21 days ahead for preparing the creative.',
  start_date_too_soon_online: 'Please select a date at least 1 day ahead',
  campaign_length_too_short: 'The campaign must be at least 1 day long',
  campaign_end_date_in_the_past:
    'The campaign end date should be in the future',
  empty_incentive: 'Please, select at least one item',
  invalid_number: 'Please, enter valid number',
  invalid_postcode: 'Invalid post code',
  hex_color: 'Use a 6-digit hex colour, for example #1b6ad3',
  invalid_email: 'Invalid email format',
  invalid_house_number: 'Invalid house number',
  invalid_phone_number: 'Invalid phone number',
  invalid_url: 'Invalid URL',
  missing_picture: 'Please upload an image to add new incentive.',

  // Additional validation messages for all error types
  max_length: 'The value is too long',
  min_length: 'The value is too short',
  invalid_type: 'Invalid type',
  invalid_string: 'Invalid text',
  invalid_enum_value: 'Invalid selection',
  invalid_arguments: 'Invalid arguments',
  invalid_return_type: 'Invalid return type',
  invalid_union: 'Invalid combination',
  invalid_union_discriminator: 'Invalid discriminator',
  invalid_literal: 'Invalid value',
  too_big: 'The value is too large',
  too_small: 'The value is too small',
  custom: 'Validation error',
  invalid: 'Invalid input',
  not_found: 'Not found',
  not_multiple_of: 'Must be a multiple of {{multipleOf}}',
  invalid_format: 'Invalid format',
  max_date: 'Date must not be later than {{maxDate}}',
  min_date: 'Date must not be earlier than {{minDate}}',
  not_optional: 'This field is required',
  unrecognized_keys: 'Unrecognized keys',
  invalid_intersection_types: 'Invalid intersection types',
  invalid_check: 'Invalid check',
}

const end_users = {
  end_users: 'End Users',
  preview: 'Preview',
  data_rows: 'Total number of users:',
  data_check: 'Data Check',
  data_upload: 'Data Upload',
  download_example: 'Download Example File',
  table_header: {
    first_name: 'First Name',
    middle: 'Infix',
    last_name: 'Last Name',
    company: 'Company',
    email: 'Email',
    phone_number: 'Phone Number',
    postal_code: 'Post Code',
    city: 'City',
    street_name: 'Street Name',
    house_number: 'House number',
    country: 'Country',
    birthday: 'Birthday',
    sku: 'SKU',
    digital_code: 'Digital Code',
    postnl_code: 'Dutch post Code',
    reference_code: 'Reference Code',
  },
  map_field_placeholder: '[Column Name]',
  missing_data: 'Looks like some data is missing',
  missing_data_text:
    'The following data is missing from the upload. Please upload a new file with the missing data.',
  upload: 'UPLOAD',
  missing: 'MISSING Or INVALID',
  errors: {
    birthday: 'Birthday yyyy-MM-dd or MM/dd/yyyy',
    firstName: 'First name',
    lastName: 'Last name',
    middle: 'Middle name',
    email: 'Email',
    email_invalid: 'Invalid email address',
    email_duplicate: 'Duplicate email address',
    sku: 'SKU',
    postnlCode: 'Dutch post code',
    referenceCode: 'Reference Code',
    postcode: 'Post code',
    postalCode: 'Post code',
  },
  ok: 'Ok, got it',
  missing_sku_codes:
    'The listed SKU codes below are missing from the existing SKU list',
  user_profile: {
    happiness_check_header: 'Happiness Check Answers',
    incentive_header: 'Incentive Details',
    incentive_name_label: 'Incentive Name',
    events_header: 'Events',
    allow_contact_consent_label: 'Allow Contact Consent',
    optional_data_header: 'Optional Data',
    mapping_header: 'Mapping Data',
    questionnaire_answers_header: 'Questionnaire Answers',
    account_info_header: 'Account Information',
    personal_details_header: 'Personal Details',
    full_name_label: 'Full Name',
    id_label: 'ID',
    email_label: 'Email',
    address_label: 'Address',
    campaigns_header: 'Campaigns',
    phone_label: 'Phone',
    birthday_label: 'Birthday',
    digital_code_label: 'Digital Code',
    privacy_link_accepted_label: 'Privacy Link Accepted',
    years_old: '{{age}} years old',
  },
  title: 'Title',
  add_new: 'Add new',
  edit_user: 'Edit user',
  edit: 'Edit',
  delete: 'Delete',
  name: 'Name',
  email: 'Email',
  phone: 'Phone',
  address: 'Address',
  unique_code: 'Unique code',
  actions: 'Actions',
  no_users: 'No users',
  first_name: 'First name',
  last_name: 'Last name',
  select_sku: 'SKU',
  sku: 'SKU',
  confirm_delete: 'Are you sure you want to delete this test user?',
  clear_answers: 'Are you sure you want to clear the answers for this user?',
}

const file_upload = {
  a: 'a',
  or: 'or',
  upload_file: 'Upload a file',
  drag_and_drop: 'or drag and drop',
  file: 'file',
  remove: 'Remove',
}

const incentives = {
  title: 'Incentive',
  referral_incentives_title: 'Referral',
  select: 'Select',
  selected: 'Selected',
  types: {
    unique_digital: 'Unique Digital Gift Code',
    universal_digital: 'Universal Digital Gift Code',
    physical: 'Physical Incentive',
    intersolve: 'Intersolve integration',
    gift_group: 'Gift Group',
  },
  sku_code: 'SKU Code',
  digital_code: 'Universal Digital Gift Code',
}

const add_incentive = {
  add_incentive: 'Add Incentive',
  upload_here: 'You can upload your own incentive here',
  upload_image_hint:
    'Recommended: 1200 × 600 px (2:1 landscape), JPG or PNG under 1 MB.',
  name: 'Incentive Name',
  price: 'Price',
  description: 'Description',
  category: 'Category',
  type: 'Type',
  customer: 'Customer',
  download_example: 'Download Example File',
  upload_voucher_code_file: 'Upload Voucher codes',
  shop: 'Shop',
  gift_group_items: 'Gift Group Items',
  gift_group_items_required: 'Select at least one gift group item',
  select_customer_first: 'Please select a customer first',
  no_gift_group_items:
    'No Intersolve or physical items available for this customer',
  locked_after_claim:
    'Locked — this incentive has already been claimed by an end user.',
}

const compose_creative = {
  title: 'Compose creative',
  sub_title: 'Type of campaign',
  offline: 'Offline',
  offline_post_card: 'Post card campaign',
  online: 'Online',
  online_email: 'Email campaign',
  postcard: 'Card',
  postcard_description: 'Post card campaign',
  flyer: 'Flyer',
  flyer_description: 'Flyer campaign',
}

const offline = {
  title_design_front: 'Post Card Design Front',
  content_design_front: 'Here you can upload your own design of the post card.',
  post_card_design: 'Post Card Design',
  title_design_back: 'Post Card Design Back',
  content_design_back:
    'Here you can upload your own logo and add text to the card',
  logo: 'Logo',
  logo_hint:
    'Recommended: 450 x 200 px for horizontal logos, 200 x 300 px for vertical logos (PNG or JPG).',
  text_on_the_back: 'Text on the back',
  landing_text_back: 'Landing text back',
  heading: 'Heading',
  add_text: 'Add text',
  preview: 'Preview',
  special_gift_awaited: 'Special Gift Awaited!',
  add_text_placeholder: 'Claim Your Incentive as our valued client!',
  form_of_address: 'Form of address',
  card_design: 'Card Design',
  info_card: {
    card_requirements: 'Card Requirements',
    post_card_design: 'Post Card Design',
    safety_margin: 'Safety Margin',
    cutting_margin: 'Cutting Margin',
    yellow: 'Yellow',
    red: 'Red',
    safety_size: ': 148 x 210mm',
    cutting_size: ': 154 x 216mm',
    safety_margin_description:
      'The safety margin (yellow border) indicates how far important elements, such as texts and logos, should remain from the edge of your design. This prevents the text from being partially cut off or standing on the edge of your printed matter.',
    cutting_margin_description:
      'Cutting margin (bleed) is the margin you keep in your design to prevent (white) cutting lines at the edge of your printed matter. We ask for a cutting margin of 3 mm per side.',
    tip: 'TIP',
    tip_description:
      'Let your background continue up to and including the red edge (the bleed), as there is minimal play here during cutting. This prevents white edges after cutting and ensures that the background continues nicely on all sides.',
  },
}

const confirmation = {
  title: 'Your Campaign is all set!',
  description:
    'You can find it and manage all your campaigns in the campaign list',
  go_to_campaign_list: 'Go to Campaign List',
}

const happiness_check = {
  module: 'Happiness Check Module',
  include: 'Include the happiness check module',
  really_negative: 'Really Negative',
  negative: 'Negative',
  alright: 'It was alright',
  positive: 'Positive',
  really_positive: 'Really positive',
}

const online = {
  email_title: 'Email Design',
  redeem_gift: 'Redeem gift',
  email_text: 'E-mail Text',
  template_image_hint:
    'Recommended: 1200 × 600 px (2:1 landscape), JPG or PNG under 1 MB.',
}

const print_files_download = {
  modal_title: 'Secure File Download',
  modal_description: `This file is protected with a password to ensure utmost security.
  To access it, please enter the correct password below. Handle it
  with care and only share it with authorized recipients.`,
  download: 'Download File',
  copied: 'Copied to clipboard',
}

const incentive_categories = {
  personal_care: 'Personal care',
  home: 'Home',
  other: 'Other',
  foods_and_drinks: 'Food & Drinks',
}

const dashboard_labels = {
  dashboard: 'Dashboard',
  general_campaign: 'General',
  referral_campaign: 'Referral',
  campaign_overview: 'Campaign Overview',
  campaign_performance: 'Campaign Performance',
  requested_incentives: 'Requested Incentives',
  by_share: 'by share',
  by_type: 'by type',
  over_time: 'over time',
  since_the_beginning_of_the_campaign: 'since beginning of campaign',
  happiness_check: 'Happiness Check',
  incentiveVoucherReserved: 'Gift vouchers reserved',
  incentiveVoucherUsed: 'Gift vouchers used',
  incentiveVoucherExpired: 'Gift vouchers expired',
  incentive_code_used: 'Incentive Code Used',
  view_customer_dashboards: 'View Customer Dashboards',
  overview: {
    campaign_reached: 'Total Reached',
    scanned_qr_codes: 'Scanned QR Codes',
    referral_link_opens: 'Referral Link Opens',
    questionnaire_started: 'Questionnaire Started',
    questionnaire_completed: 'Questionnaire Completed',
    incentives_requested: 'Incentives Requested',
    scanned_qr_codes_online: 'Unique clicks on the link',
    referral_link_opens_online: 'Referral Link Opens',
    questionnaire_started_online: 'Started the flow',
    questionnaire_completed_online: 'Questionnaire Completed',
    incentives_requested_online: 'Incentives Requested',
    incentiveVoucherReserved: 'Gift vouchers reserved',
    incentiveVoucherUsed: 'Gift vouchers used',
    incentiveVoucherExpired: 'Gift vouchers expired',
  },
  performance_by_time: {
    general: {
      reached: 'Nr. QR codes scanned / web visits',
      incentiveRequested: 'Incentives requested',
      questionnaireStarted: 'Started Questionnaires',
      questionnaireCompleted: 'Completed Questionnaires',
      incentiveVoucherReserved: 'Gift vouchers reserved',
      incentiveVoucherUsed: 'Gift vouchers used',
      incentiveVoucherExpired: 'Gift vouchers expired',
      resetVoucherCode: 'Voucher code reset',
    },
    referral: {
      reached: 'Referral link opens',
      incentiveRequested: 'Incentives requested',
      questionnaireStarted: 'Started Questionnaires',
      questionnaireCompleted: 'Completed Questionnaires',
      incentiveVoucherReserved: 'Gift vouchers reserved',
      incentiveVoucherUsed: 'Gift vouchers used',
      incentiveVoucherExpired: 'Gift vouchers expired',
      resetVoucherCode: 'Voucher code reset',
    },
  },
}

const tooltips = {
  generate_files: 'Generate Files',
  send_email: 'Send Email',
  download_user_data: 'Download User Data',
  download_creative: 'Download Print Files',
}

const flyer = {
  title: 'Flyer design',
  front: 'Front',
  info_card: {
    flyer_requirements: 'Flyer Requirements',
    safety_margin: 'Safety Margin',
    cutting_margin: 'Cutting Margin',
    yellow: 'Yellow',
    red: 'Red',
    safety_size: ': 210 x 148mm',
    cutting_size: ': 216 x 154mm',
  },
}

const campaign_categories = {
  title: 'Campaign Category',
  generic: 'Generic',
  birthday: 'Birthday',
  lottery: 'Lottery',
  generic_description:
    'Simply upload your data list and send tailored creatives and incentives to your audience',
  birthday_description:
    'A birthday campaign enables sending incentives for your client’s birthday',
  lottery_description:
    'Retrieve your lottery draw results and share them with your customers',
}

const campaign_status = {
  active: 'In Progress',
  completed: 'Done',
}

const api_integration = {
  generic_header: 'Generic Campaign',
  generic_text:
    'Please select the date range for the customer data you want to download from the API.',
  lottery_text:
    'Please select one or several lottery submission forms for the customer data you want to download from the API.',
  lottery_header: 'Lottery Campaign',
  sync: 'Sync API Connection',
  generic_text_three_draws:
    'Please select the date for the customer data you want to download from the API.',
  purchases: 'Purchase Winners',
  purchases_description:
    'Import winners based on purchase data for your selected date range.',
  three_draws_and_prize: 'Three Draws & Prize',
  three_draws_and_prize_description:
    'Import winners from the three draws system for your selected date.',
}

const incentive_errors_modal = {
  delete_error_modal_title: "This incentive item can't be deleted",
  delete_incentive_item_is_used:
    'Incentive item is used {{numberOfCampaigns}} campaign',
  delete_incentive_with_used_voucher_codes:
    'The attached incentive has used voucher codes',
  update_error_modal_title:
    'This gift is featured in {{numberOfCampaigns}} campaigns',
  update_incentive_item_is_used:
    'The selected incentive is currently featured in {{numberOfCampaigns}} campaigns. If you want to deactivate it you should deselect the incentive from the campaigns',
}

const incentives_store = {
  title: 'Incentives',
  new_incentive: 'New Incentive',
  featured: 'Featured',
  product_info: 'Product info',
  price: 'Price',
  category: 'Category',
  description: 'Description',
  claimed: 'Claimed',
  disabled_active: 'Disabled/Active',
  pcs: 'pcs',
  add_incentive: 'Add New Incentive',
  active: 'Active',
  status: 'Incentive Status',
  uploaded_files: 'Uploaded Files',
  add: 'Add Incentive',
  no_incentives: 'No incentives added for this customer yet.',
  please_add: 'Please add a new incentive',
  featured_tooltip: 'Featured in {{numberOfCampaigns}} campaigns',
  previous: 'Previous',
  next: 'Next',
  all_customers: 'All Customers',
  all_categories: 'All Categories',
  search_placeholder: 'Search Incentive',
  pagination_info: 'Page {{currentPage}}',
}

const ec = {
  hello: 'Hello',
  dear: 'Dear',
  yes_button: 'Yes! Claim my gift',
  back: 'Back',
  next: 'Next',
  happiness_check_button: 'Happiness check',
  finish: 'Finish',
  home: {
    header: 'Congratulations!',
    text: 'Check out the amazing prize you have won.',
  },
  choose_incentive: {
    title: 'A Gift for you!',
    sub_title:
      'As our valued customer you can claim your gift now and be surprised.',
    header: 'CHOOSE ONE GIFT',
    header_lottery: 'YOUR PRIZE',
    validation: 'Please select an incentive to continue',
    code_has_expired:
      'Your voucher code has expired, please select an incentive again',
  },
  happiness_check: {
    title: 'Let us know about your experience',
    validation: 'Please select an option to proceed',
  },
  invite: {
    title: 'Send a gift from us to your friends as well',
    sub_title: 'Just share the link below',
    share_msg: 'I have a gift for you',
    share_msg_heart_foundation:
      'As a collector for the Heart Foundation, I got to choose a gift. You can too! What will you choose?',
    share_msg_bmw:
      'Hi, Ik ga naar het preview event van de nieuwe BMW iX3. Wellicht is het ook voor jou interessant om die auto te bekijken. Je kunt je aanmelden via:',
    copy: 'Copy',
    share: 'Share',
    copied: 'Copied to the clipboard',
  },
  questionnaire: {
    title: 'A few more steps to go',
    termsAndConditions: {
      text1: 'Yes, I would like to receive a gift and agree that:',
      text2: 'My personal data will be used to process my order',
      text3: 'may contact me for relevant campaigns',
      text4:
        'Your personal data is necessary to process the order. Your personal data will be protected in accordance with the privacy policy ofYour personal data is necessary to process the order. Your personal data will be protected in accordance with the privacy policy of',
    },
  },
  success: {
    title: 'Your gift is on the way!',
    sub_title: 'Check your email for more details',
    flyer_title: 'Thank you!',
    title_with_happiness_check: 'All set let us know about your experience',
  },
  expired: {
    title: "Oops! This QR Code didn't work out.",
    description:
      "It might be because the campaign expired or the gift's already been claimed.",
    termsAndConditions: 'Terms and Conditions',
  },
}
const ec_flow_texts = {
  home: 'Home Page',
  incentive: 'Incentive Page',
  questionnaire: 'Questionnaire Page',
  invite: 'Invite Page',
  happiness_check: 'Happiness Check Page',
  success: 'Success Page',
  expired: 'Expired Page',
  sub_header:
    'You can choose and adjust the text of the screens for your end customer below',
  end_user: 'End User',
  referral: 'Referral',
  original_receiver: 'Original receiver',
  invited: 'Received by invite',
  header: 'Header',
  text: 'Text',
  termsAndConditions: 'Terms & Conditions text',
  termsAndConditionsEndUser: 'Terms & Conditions for end user',
  termsAndConditionsReferral: 'Terms & Conditions for referral user',
  termsAndConditionsMarketing: 'Terms & Conditions for marketing',
  termsAndConditionsSummary: 'Terms & Conditions Summary',
  subject: 'Subject',
  email_text: 'E-mail Text',
  preview_link: 'Preview_link',
  copy_link: 'Copy link to preview directly in your browser/mobile phone',
  get_link: 'Get link',
  buttons_title: 'Button texts',
  buttons_help: 'A text applies to every screen with this button.',
  button_view: 'Home screen button',
  button_next: 'Next button',
  button_back: 'Back button',
  button_finish: 'Finish button',
  button_copy: 'Copy button',
  button_share: 'Share button',
  button_copied: 'Message after copying',
  error_language: 'Error message language',
  error_language_nl: 'Nederlands',
  error_language_en: 'English',
}

const emails = {
  header: 'Emails',
  text: 'Here you can change the email text the your end customers are going to receive',
  add_email: 'Add new email',
  emails_description:
    'Select triggers to craft personalized emails for your customers.',
  edit_email: 'Edit email',
  toast: 'This trigger already exists',
  toast_description: 'Please choose a different trigger',
  successfully_selected_incentive: 'Successfully Selecting an Incentive',
  no_action_taken: 'No Action Taken',
  incomplete_online_process: 'Incomplete Online Process',
  happiness_check: 'Happiness Check',
  trigger: 'Trigger',
  trigger_description: 'Please select a trigger first',
  send_out: 'To be send out',
  rating_4: 'If rating score is 4',
  rating_5: 'If rating score is 5',
  rating: 'Rating Selection',
  select_rating: 'Please select a rating',
  email_heading: 'Email Heading',
  email_text: 'Email Text',
  delete_email: 'Delete email',
  emails: 'E-mails',
  email_sent_24h_after: 'Email will be sent 24h after the trigger',
}
const sku_builder = {
  add_sku: 'New SKU Code',
  update_sku: 'Update SKU',
  sku_code: 'SKU Code',
  sku_list: 'SKU List',
  no_sku: 'SKU not Exist',
  please_add_sku: 'Please add SKU Code',
  incentives: 'Incentive Store',
  search_placeholder: 'Search',
  add_sku_code: 'Add SKU Code',
  update_sku_code: 'Update SKU Code',
  featured_tooltip: 'Featured in {{numberOfIncentives}} incentives',
  assigned: 'Assigned',
  assign_incentive: 'Assign Incentive',
  select_incentives: "Select Incentive's",
  search_incentives: 'Search incentives...',
  no_incentives_found: 'No incentives found',
  sku_exists: "SKU code '{{name}}' already exists",
}
const email_notification_texts = {
  noActionTaken: {
    header: 'Complete Your Incentive Selection',
    text: "We noticed you haven't selected your incentive yet. Don't miss out on this opportunity!",
  },
  incompleteOnlineProcess: {
    header: 'Your Incentive Selection is Incomplete',
    text: "You're almost there! Complete your incentive selection process to claim your reward.",
  },
  happinessCheck: {
    header: 'Share Your Positive Experience',
    text: "Thank you for your positive feedback! We'd love if you could share your experience.",
  },
}

const questionnaire_builder = {
  picture_choice: 'Picture choice',
  text_field: 'Text field',
  long_text_field: 'Long text field',
  radio_field: 'Gender selection',
  dynamic_radio_group: 'Multiple choice',
  dropdown_field: 'Dropdown field',
  date_field: 'Date field',
  toggle_field: 'Toggle field',
  checkbox_field: 'Checkbox field',
  question: 'Question',
  required: 'Required',
  drag_and_drop_question: 'Drag and drop question',
  blocks_section: 'from the "Blocks" section',
  blocks: 'Blocks',
  delete_question: 'Delete Question',
  min_length: 'Min length',
  max_length: 'Max length',
  add_new_question: 'Add new question',
  upload_pictures: 'Upload Pictures',
  picture_upload_hint:
    'For the best result use landscape images with a 2:1 ratio (recommended 1200 × 600 px), keep the subject centered, and use the same ratio for every option.',
  email: 'Email',
  questionnaire: 'Questionnaire',
  questionnaire_description:
    'You can choose and adjust the text of the screens for your end customer below',
  please_edit_fields: 'Complete these questions before continuing:',
  unnamed_field: 'Unnamed field',
  missing_options: 'add at least one option',
  missing_label: 'give the question a title',
}

const end_users_page = {
  title: 'End Users',
}

const end_user_list = {
  filter_by_customer: 'Filter by Customer',
  search_label: 'Search End Users',
  table_header_customer: 'Customer',
  table_header_name: 'Name',
  table_header_email: 'Email',
  table_header_address: 'Address',
  table_header_campaigns: 'Campaigns',
  table_header_actions: 'Actions',
  view_profile_action: 'View Profile',
  pagination_page_info: 'Page {{currentPage}}',
  pagination_previous: 'Previous',
  pagination_next: 'Next',
  search_placeholder: 'Search...',
  all_customers: 'All Customers',
}

const dashboard = {
  hello_user: 'Hello, {{user}}!',
  view_campaign_dashboards: 'View Campaign Dashboards',
  last_month: 'Last month',
  last_quarter: 'Last quarter',
  last_year: 'Last year',
  select_customer: 'Select customer',
  all_customers: 'All Customers',
  select_campaigns: 'Select campaigns',
  all_campaigns: 'All Campaigns',
  question_context: 'Question Type',
  question_context_all: 'All Questions',
  question_context_standard: 'Standard',
  question_context_referral: 'Referral',
  total_reach_rate: 'Total Reach Rate',
  reach_rate_subtitle: 'Percentage of users who reached the campaign',
  data_enrichment_score: 'Data Enrichment Score',
  enrichment_subtitle: 'Average questionnaire completion rate',
  incentive_claim_rate: 'Incentive Claim Rate',
  incentive_subtitle: 'Percentage of users who claimed incentives',
  average_happiness_score: 'Average Happiness Score',
  happiness_subtitle: 'Average rating from users who provided feedback',
  loading: 'Loading...',
  error: 'Error',
  no_data_available: 'No data available',
  no_ratings_yet: 'No ratings yet',
  responses: 'responses',
  users: 'users',
  questions: 'questions',
  engagement: {
    no_data_available: 'No engagement data available for the selected period.',
    title: 'QR Code Engagement Rate',
    loading: 'Loading...',
    loading_data: 'Loading engagement data...',
    qr_email_opens: 'QR/Email Opens',
    gift_selection: 'Gift Selection',
    questions_optional: 'Questions (opt)',
    started_questionnaire: 'Started Questionnaire',
    claimed_gift: 'Claimed Gift',
    ratings_given: 'Ratings Given',
    shared_referrals: 'Shared w/Referrals',
    quick_response: 'Quick Response',
    overall_score: 'Overall Engagement Score',
    score_description:
      'Percentage of total audience that completed the full engagement funnel and claimed their gift.',
    calculation_label: 'Calculation:',
    calculation_description: 'Claimed Gift ÷ Total Audience',
    higher_score_label: 'Higher score =',
    higher_score_description: 'More users completing the full journey',
    total_users: 'total users',
    of_users: 'of {{count}} users',
    average_engagement:
      'On average, {{score}}% of your audience engages in each activity',
    score_low: 'Low (0-25%)',
    score_good: 'Good (26-50%)',
    score_great: 'Great (51-75%)',
    score_excellent: 'Excellent (76%+)',
  },
  charts: {
    bar_chart_horizontal: 'Bar Chart - Horizontal',
    horizontal_bar_description: 'A horizontal bar chart',
    trending_up: 'Trending up by 5.2% this month',
    visitors_last_months: 'Showing total visitors for the last 6 months',
    yes_no_responses: 'Yes/No responses',
    no_responses_yet: 'No responses yet',
    respondents_selected_yes: '{{count}} of {{total}} people answered "Yes"',
    yes: 'Yes',
    no: 'No',
    total_responses: '{{count}} people answered in total',
    email_responses_excluded: 'Email responses are excluded from visualization',
    email_privacy_message:
      'Email responses are not displayed for privacy reasons',
    responses_collected: '{{count}} responses collected',
    recent_responses_last_3: 'Recent responses (last 3)',
    recent_responses_last_5: 'Recent responses (last 5)',
    recent_responses_showing:
      'Recent responses (showing {{showing}} of {{total}} total)',
    submitted_on: 'Submitted on {{date}}',
    gender_distribution: 'Gender distribution',
    people_answered_one: '{{count}} person answered',
    people_answered_other: '{{count}} people answered',
    count: 'Count',
    desktop: 'Desktop',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    response_distribution: 'Response distribution',
    picture_choice_distribution: 'Picture choice distribution',
    legend: 'Legend',
    other: 'Other',
    ages: 'Age distribution in 10-year buckets',
    ages_count:
      'Age distribution in 10-year buckets ({{count}} people answered)',
    multi_select_distribution: 'Multi-select distribution',
    multi_select_distribution_count:
      '{{totalRespondents}} people answered, {{totalSelections}} selections in total',
    failed: 'Failed to load chart data: {{error}}',
    export_csv: 'Export CSV',
  },
  risk_factors: {
    title: 'Risk Factors Analysis',
    subtitle:
      'Interactive analysis of user engagement risks across {{count}} total users',
    export_options: 'Export Options',
    export_csv: 'Export CSV',
    export_dialog_title: 'Export Risk Factors',
    select_risk_types: 'Select Risk Types to Export:',
    never_opened: 'Never Opened',
    low_satisfaction: 'Low Satisfaction',
    non_responders: 'Non-Responders',
    safe_users: 'Safe Users',
    total_at_risk: 'Total At Risk',
    safe_users_count: '{{count}} of total users',
    no_risk_data: 'No risk data available for the selected period.',
    count_label: 'Count:',
    percentage_label: 'Percentage:',
    selections: '{{count}} selections',
    of_users: 'of {{count}} users',
    safe_users_desc: 'Users with no identified risk factors',
    select_at_least_one: 'Please select at least one risk type to export.',
    auth_required: 'Authentication required. Please log in again.',
    export_failed: 'Failed to export CSV: {{error}}',
    empty_csv: 'Empty CSV response',
    of_total_users: 'users',
  },
  top_incentives: {
    title: 'Top 6 Most Selected Incentives',
    description: 'Discover the top gift choices made by our users.',
    error_loading: 'Error loading incentives',
    no_data_available:
      'No incentive selection data available for the selected period.',
    selections_count: 'Selections: {{count}} ',
    of_total_users: 'Chose a gift: {{count}} ',
    voucher_codes:
      'Vouchers: {{used}} used, {{free}} available ({{total}} total)',
    chosen_gifts_title: 'Chosen in the gift portal',
    show_chosen_gifts: 'Show the gifts recipients chose',
    hide_chosen_gifts: 'Hide the gifts recipients chose',
    times_chosen: 'Chosen: {{count}}',
    no_chosen_gifts:
      'No gift was chosen in this gift group in the selected period.',
  },
  campaign_questions: {
    title: 'Campaign Questions',
    loading_summary: 'Loading summary...',
    campaigns_label: 'Campaigns: {{count}}',
    avg_completion_label: 'Avg Completion: {{rate}}%',
    total_users_label: 'Total Users: {{count}}',
    unable_to_load: 'Unable to load summary data',
    loaded_questions: 'Loaded {{loaded}} of {{total}} questions',
    select_header: 'Select',
    question_header: 'Question',
    type_header: 'Type',
    customer_header: 'Customer',
    campaign_header: 'Campaign',
    status_header: 'Status',
    unknown_type: 'unknown',
    scroll_for_more: 'Scroll for more',
    selected_analysis:
      'Selected Questions Analysis ({{count}} questions selected)',
    questions_selected: '{{count}} questions',
    selected_questions: 'Selected: {{count}} question(s)',
    questions_label: 'Questions:',
    no_questions_found: 'No questions found',
    error_loading_questions: 'Error: {{message}}',
    reset_selection: 'Reset Selection',
  },
}

const translation = {
  emails,
  ec_flow_texts,
  ec,
  locale: 'en-US',
  yes: 'Yes',
  no: 'No',
  na: 'N/A',
  save_draft: 'Save Draft',
  next_step: 'Next Step',
  save_campaign: 'Save Campaign',
  language: 'Language',
  calendar: 'Calendar',
  loading: 'Loading',
  create: 'Create',
  close: 'Close',
  details: 'Details',
  cancel: 'Cancel',
  formal: 'Formal',
  informal: 'Informal',
  save_to_preview: 'Save to load preview',
  download_front_pdf: 'Download front pdf',
  download_back_pdf: 'Download back pdf',
  upload_csv_error:
    'The file is not in the correct format. Please use the same format as the format in the example file!',
  repeat_incentive: 'Add same incentives for referral campaign',
  dear: 'Dear',
  hello: 'Hello',
  current_month: 'Current month',
  required: 'Required',
  sku_not_exist: 'This SKU code "{{sku}}" does not exist in uploaded data',
  sku_exist: 'This SKU code "{{sku}}" already exist',
  skuCodes_not_match_data_upload:
    'SKU codes "{{sku}}" exist in the uploaded data but not in the selected incentive items',
  // Server-side guard error codes (NestJS BadRequestException `error` field).
  // Used directly as i18n keys via t(body.error) — keep keys in sync with
  // the server constants in gift-group-theme-validator.ts and IncentiveService.
  campaign_has_no_incentives:
    'This campaign has no incentives attached. Open it and attach at least one incentive on the Incentives step before launching.',
  gift_group_theme_missing:
    'This customer has no gift portal theme configured. Open Settings → Theme → Details and set a slug before attaching a gift group incentive.',
  incentive_customer_mismatch:
    'You cannot attach an incentive that belongs to a different customer than the campaign.',
  incentive_customer_missing_intersolve:
    'The selected customer has no Intersolve integration. Add one in Settings → Integrations before creating intersolve or gift group incentives.',
  incentive_claimed_frozen_fields:
    'This incentive has already been claimed. Customer, type, and Intersolve shop cannot be changed anymore. You can still edit name, price, description, image, and category.',
  incentive_integration_customer_mismatch:
    "The selected Intersolve shop does not belong to this customer. Pick a shop from the new customer's shops.",
  gift_group_child_customer_mismatch:
    'Gift group items must belong to the same customer as the parent incentive.',
  gift_group_child_not_found:
    'One or more selected gift group items no longer exist. Refresh the page and pick the items again.',
  gift_group_child_type_not_allowed:
    'A gift group can only offer Intersolve or physical incentives. Remove the other items from the selection.',
  gift_group_child_type_locked:
    'This incentive is offered inside a gift group, so its type must stay Intersolve or physical. Remove it from the gift group first.',
  delete_incentive_with_used_voucher_codes:
    'This incentive cannot be deleted because it has been claimed by an end user.',
  failed_to_attach_incentives: 'Failed to attach incentives.',
  failed_to_execute_campaign: 'Failed to execute campaign.',
  campaigns_on: 'campaigns on',
  delete: 'Delete',
  delete_campaign: 'Delete Campaign',
  are_you_sure: 'Are you sure you want to delete this campaign?',
  deleting_campaign:
    'Deleting the campaign will remove it from the list and the dashboard.',
  multiselect_placeholder: 'Select an option',
  previous_campaign: 'Previous Campaign',
  day: 'Day',
  edit: 'Edit',
  disable: 'Disable',
  api_integration,
  next: 'Next Screen',
  save: 'Save',
  mobile_view: 'Mobile View',
  pick_a_date: 'Pick a date',
  salutation: 'Salutation (Aanhef)',
  previous_screen: 'Previous Screen',
  character: 'Character left',
  characters: 'Characters left',
  upload_image: 'Upload Image',
  languages,
  progress_bar,
  campaign_details,
  navigation,
  campaign_list,
  questionnaire,
  validation_messages,
  end_users,
  file_upload,
  optional_question,
  incentives,
  add_incentive,
  compose_creative,
  offline,
  confirmation,
  happiness_check,
  online,
  print_files_download,
  incentive_categories,
  dashboard_labels,
  tooltips,
  flyer,
  campaign_categories,
  campaign_status,
  incentive_errors_modal,
  incentives_store,
  sku_builder,
  email_notification_texts,
  questionnaire_builder,
  end_users_page, // Added
  end_user_list, // Added
  dashboard, // Added
}

export default translation

export type Translations = typeof translation
